@if (sponsor?.image_url) {
  <a target="_blank" class="sponsor-banner" (click)="postEvent()">
    <figure>
      <img [src]="imageSrc" alt="sponsor banner" [style.aspect-ratio]="imageAspectRatio" />
    </figure>
  </a>
}
